import React, { useState, useEffect } from "react";
import "./LandingPage.css";
// Import the new Header component!
import Header from "./Components/Header/Header"; // Adjust the path if you saved it elsewhere
import MobileOtpPage from "./Components/LeadCaptureForm/MobileOtpPage";
import OfferPage from "./Components/LeadCaptureForm/OfferSection/OffersPage";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../utility/setUserClickData";
import Partners from "./Components/Partners/Partners";
import InfoSections from "./Components/OurInfo/InfoSections";
import FAQ from "./Components/FAQs/FAQ";
import Footer from "./Components/Footer/Footer";

const LandingPage = () => {
  const [isFormStarted, setIsFormStarted] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [params] = useSearchParams();
  const [showOfferHeaderLogo, setShowOfferHeaderLogo] = useState(false);

  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const source = params.get("source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmTerm = params.get("utm_term") || "";
  const adsName = params.get("ads_name") || "";
  const leadId = params.get("lid") || "";
  const ldId = params.get("ld_id") || "";

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem("isFormStarted");
    };

    const sessionFlag = sessionStorage.getItem("isFormStarted");
    if (sessionFlag === "true") {
      setIsFormStarted(true);
    }
    setUserClickData({
      event_name: "pageview-for-gold-loan-v2",
      utm_source: utmSource,
      utm_medium: utmMedium,
      user_id: ldId || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
  }, []);

return (
  <div id="v3-strict-scope" className="landing-page-container-offer-v2">
      
      {/* 1. RENDER HEADER ONLY IF FORM HASN'T STARTED OR IS ON STEP 1 */}
      {(!isFormStarted || currentStep === 1) && <Header />}

      <div>
        <div id="personal-loan-form">
          {currentStep === 1 && (
            <MobileOtpPage
              isFormStarted={isFormStarted}
              setIsFormStarted={() => {
                sessionStorage.setItem("isFormStarted", "true");
                setIsFormStarted(true);
              }}
              setCurrentStep={setCurrentStep}
              currentStep={currentStep}
              formData={formData}
              setFormData={setFormData}
            />
          )}

          {currentStep === 2 && (
            <OfferPage

              pincode={formData?.pincode || localStorage.getItem("pincode")} 
              name={formData?.name || localStorage.getItem("user_name")}
              formData={formData}
              setFormData={setFormData}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              affId={affId}
              utmSource={utmSource}
              source={source}
              utmMedium={utmMedium}
              utmTerm={utmTerm}
              setShowOfferHeaderLogo={setShowOfferHeaderLogo}
            />
          )}
        </div>

        {/* 2. RENDER THE REST OF THE PAGE SECTIONS ONLY IF ON STEP 1 */}
        {(!isFormStarted || currentStep === 1) && (
          <div style={{ maxWidth: "1280px", margin: "0 auto", width: "100%" }}>
            <Partners />
            <InfoSections />
            <div id="faqs"><FAQ/></div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;